/**
 * Perform basic arithmetic operations on currency
 * @returns
 */
export function useCurrencyArithmetic() {
  const toCents = (amount: number) => Math.round(amount * 100);
  const toDollars = (amount: number): number => parseFloat((amount / 100).toFixed(2));

  /**
   * Add multiple currency values
   * @param args
   * @returns
   */
  const add = (...args: number[]): number => {
    const sum = args.reduce((acc, curr) => acc + toCents(curr), 0);
    return toDollars(sum);
  };

  /**
   * Subtract multiple currency values
   * @param args
   * @returns
   */
  const subtract = (...args: number[]): number => {
    if (args.length < 2) {
      return args[0];
    }

    const difference = args.splice(1).reduce((acc, curr) => acc - toCents(curr), toCents(args[0]));
    return toDollars(difference);
  };

  /**
   * Multiply currency by an integer
   * @param currency
   * @param integer
   * @returns
   */
  const multiply = (currency: number, integer: number): number => {
    if (currency === 0 || integer === 0) return 0;

    if (!Number.isInteger(integer)) {
      throw new Error('Multiplication of floating point numbers is not supported');
    }

    const product = toCents(currency) * integer;
    return toDollars(product);
  };

  return {
    add,
    subtract,
    multiply,
  };
}
